function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { createFrame as createStripeThirdPartyFrame } from '@stripe-internal/stripethirdparty/no-ui';
import { Cookies, LocalStorage } from '@stripe-internal/stripe-cookies';
import { pollUntil } from '../util';
const mountGTMFrame = (config)=>createStripeThirdPartyFrame(config);
const INPUT_TAGS = {
    initialize: 'INITIALIZE_GOOGLE_TAG_MANAGER',
    checkLoaded: 'CHECK_GTM_LOADED',
    trackRaw: 'TRACK_RAW'
};
export class GoogleTagManagerProvider {
    ready() {
        var _this = this;
        return _async_to_generator(function*() {
            if (_this.readyPromise) {
                return _this.readyPromise;
            }
            _this.readyPromise = new Promise((resolve, _reject)=>{
                const createFrame = ()=>{
                    const gtmAvailable = function() {
                        var _ref = _async_to_generator(function*() {
                            if (!_this.stripeThirdPartyFrame) return false;
                            const { isGTMLoaded } = yield _this.stripeThirdPartyFrame.sendRequest({
                                tag: INPUT_TAGS.checkLoaded
                            });
                            return isGTMLoaded;
                        });
                        return function gtmAvailable() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    _this.stripeThirdPartyFrame = mountGTMFrame({
                        baseURL: _this.frameUrl,
                        type: 'GoogleTagManager',
                        onReady: function() {
                            var _ref = _async_to_generator(function*(sendMessage) {
                                sendMessage({
                                    tag: INPUT_TAGS.initialize,
                                    message: {
                                        apiKey: _this.gtmId
                                    },
                                    setupOptions: {
                                        cookieDomain: '.stripe.com'
                                    }
                                });
                                yield pollUntil(gtmAvailable, {
                                    maxIterations: 50,
                                    interval: 100
                                });
                                yield _this.fetchCookieSettings();
                                _this.initialized = true;
                                resolve(true);
                            });
                            return function(sendMessage) {
                                return _ref.apply(this, arguments);
                            };
                        }(),
                        frameAttributes: {
                            class: 'ThirdPartyFrame'
                        }
                    });
                    document.body.appendChild(_this.stripeThirdPartyFrame.frame);
                };
                if (_this.deferLoading && 'requestIdleCallback' in window) {
                    window.requestIdleCallback(createFrame, {
                        timeout: 5000
                    });
                } else {
                    setTimeout(createFrame, 0);
                }
            });
            return _this.readyPromise;
        })();
    }
    trackEvent({ action, category, label, value, url, description }) {
        var _this = this;
        return _async_to_generator(function*() {
            if (!_this.stripeThirdPartyFrame) return;
            const data = {
                event: 'event',
                category,
                label,
                action,
                value,
                url,
                description,
                allowedCookies: _this.cookieCategories
            };
            if (data.url) {
                const modifiedUrl = new URL(data.url);
                Object.entries(_this.utmParameters).forEach(([k, v])=>{
                    modifiedUrl.searchParams.append(k, String(v));
                });
                data.url = modifiedUrl.href;
            }
            // transform all numeric values in data to strings
            // and remove all undefined values
            const params = Object.entries(data).filter(([_, v])=>v !== undefined).map(([key, v])=>[
                    key,
                    String(v)
                ]).reduce((acc, [key, v])=>_object_spread_props(_object_spread({}, acc), {
                    [key]: v
                }), {});
            const payload = _object_spread({
                tag: INPUT_TAGS.trackRaw
            }, params);
            _this.stripeThirdPartyFrame.sendMessage(payload);
        })();
    }
    trackPage(_param) {
        var _this = this;
        return _async_to_generator(function*() {
            var { path } = _param, pageMetadata = _object_without_properties(_param, [
                "path"
            ]);
            if (!_this.stripeThirdPartyFrame) return;
            yield _this.sendCookieSettings();
            const payload = _object_spread({
                tag: INPUT_TAGS.trackRaw,
                event: 'pageview',
                url: path,
                allowedCookies: _this.cookieCategories
            }, pageMetadata);
            _this.stripeThirdPartyFrame.sendMessage(payload);
        })();
    }
    // eslint-disable-next-line class-methods-use-this
    trackVitals(_) {
        return _async_to_generator(function*() {
        // no-op
        })();
    }
    setExperimentTreatment({ experimentId, variantId }) {
        var _this = this;
        return _async_to_generator(function*() {
            if (!_this.stripeThirdPartyFrame) return;
            const payload = {
                tag: INPUT_TAGS.trackRaw,
                exp: `${experimentId}.${variantId}`
            };
            _this.stripeThirdPartyFrame.sendMessage(payload);
        })();
    }
    fetchCookieSettings() {
        var _this = this;
        return _async_to_generator(function*() {
            const cookies = new Cookies();
            _this.allowedCookieCategories = Object.entries({
                advertising: yield cookies.isCategoryAllowed('advertising'),
                functional: yield cookies.isCategoryAllowed('functional')
            }).flatMap(([key, allowed])=>allowed ? [
                    key
                ] : []);
        })();
    }
    sendCookieSettings() {
        var _this = this;
        return _async_to_generator(function*() {
            if (!_this.stripeThirdPartyFrame) return;
            _this.stripeThirdPartyFrame.sendMessage({
                tag: INPUT_TAGS.trackRaw,
                allowedCookies: _this.cookieCategories
            });
        })();
    }
    get cookieCategories() {
        return this.allowedCookieCategories.join(',');
    }
    get utmParameters() {
        let utmParams = {};
        const imt = this.storage.get('imt');
        if (imt) {
            const pEntries = JSON.parse(imt).p;
            const recentParams = pEntries.reverse().map((entry)=>entry.p).find((p)=>{
                return Object.prototype.hasOwnProperty.call(p, 'utm_medium');
            }) || {};
            const paramNames = [
                'utm_medium',
                'utm_source',
                'utm_campaign',
                'utm_content',
                'utm_term'
            ];
            utmParams = Object.fromEntries(Object.entries(recentParams).filter(([key, value])=>paramNames.includes(key) && value !== ''));
        }
        return utmParams;
    }
    constructor({ gtmId, frameUrl, deferLoading = false }){
        _define_property(this, "gtmId", void 0);
        _define_property(this, "frameUrl", void 0);
        _define_property(this, "deferLoading", void 0);
        _define_property(this, "allowedCookieCategories", []);
        _define_property(this, "stripeThirdPartyFrame", null);
        _define_property(this, "initialized", false);
        _define_property(this, "storage", new LocalStorage());
        _define_property(this, "readyPromise", null);
        this.gtmId = gtmId;
        this.frameUrl = frameUrl;
        this.deferLoading = deferLoading;
    }
}

//# sourceMappingURL=GoogleTagManager.js.map